exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pic-box{width:100%;height:100%;background-color:#fff;position:relative}.pic-box .auto-position{position:absolute;top:50px}.pic-box .pic-display{width:100%;height:100%;overflow:hidden}.pic-box .pic-display .pic{display:block}.pic-box .fullscreen-mode{background-color:#000}.pic-box .sideBar{position:fixed;bottom:60px;visibility:hidden}.pic-box .sideBar li{text-align:center;border:1px solid;display:inline-block;width:40px;height:40px;line-height:40px}.pic-full-screen .auto-position{top:150px}.pic-full-screen .notice{background-color:#484848;opacity:.8}", ""]);

// exports
